import { render, staticRenderFns } from "./points-address.vue?vue&type=template&id=7f66524e&"
import script from "./points-address.vue?vue&type=script&lang=js&"
export * from "./points-address.vue?vue&type=script&lang=js&"
import style0 from "./points-address.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports